import AjaxService from '@services/AjaxService';
import BaseRepository, {SelectOption} from '@repositories/desktop/BaseRepository';
import UrlParameterInterface from '@repositories/UrlParameterInterface';

export default class MarketingVisitRepository extends BaseRepository {
  protected baseUrl = '/api/desktop/marketing-visits';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}`, {data: {attributes}});
  }

  public delete(visitId: number): Promise<any> {
    return this.ajaxService.sendDelete(`${this.baseUrl}/${visitId}/delete`);
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/blank`);
  }

  public getCategoryOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/category`)
      .then(r => r.data.attributes.options);
  }

  public getFirmOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/firm`)
      .then(r => r.data.attributes.options);
  }

  public getPersonOptions<T = number | string>(firmId?: number): Promise<Array<SelectOption<T>>> {
    const params: UrlParameterInterface | undefined = firmId ? {firmId} : undefined;
    return this.ajaxService.getJsonWithParameters(`${this.baseUrl}/options/person`, params)
      .then(r => r.data.attributes.options);
  }

  public getSendCopyToOptions<T = number | string>(): Promise<Array<SelectOption<T>>> {
    return this.ajaxService.getJson(`${this.baseUrl}/options/send-copy-to`)
      .then(r => r.data.attributes.options);
  }

  public getVisitedUserOptions<T = number | string>(firmId?: number): Promise<Array<SelectOption<T>>> {
    const params: UrlParameterInterface | undefined = firmId ? {firmId} : undefined;
    return this.ajaxService.getJsonWithParameters(`${this.baseUrl}/options/visited-user`, params)
      .then(r => r.data.attributes.options);
  }

  public loadOverview(visitId: number): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/${visitId}`);
  }

  public reloadCreateBasedata(attributes: any): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}/reload`, {data: {attributes}});
  }

  public saveBasedata(visitId: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `${this.baseUrl}/${visitId}/basedata/save`,
      {data: {attributes}}
    );
  }
}
